import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Type } from '@spotify-internal/encore-creator-web';
import styles from './index.module.scss';
import {
  LOADING,
  ERROR,
  selectNetworkFollowers,
  selectNetworkFollowersStatus,
  selectDateRange,
} from '../../../store/selectors';
import { loadNetworkFollowers } from '../../../store/networkFollowers';
import { PerformanceOverTimeChart } from '../../../components/Shared/Charts/PerformanceOverTimeChart';
import { LoadingIndicator } from '../../../components/Shared/LoadingIndicator';
import { Follower, DateRangeWithLabel, ReduxState } from '../../../types';
import { FormattedMessage } from 'react-intl';

type Props = {
  followers?: Follower[];
  status?: 'LOADING' | 'ERROR';
  networkId: string;
  loadNetworkFollowers: typeof loadNetworkFollowers;
  dateRange?: DateRangeWithLabel;
};

class NetworkFollowers extends PureComponent<Props> {
  componentDidMount() {
    this.props.loadNetworkFollowers(this.props.networkId);
  }

  /* istanbul ignore next */
  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (!this.props.dateRange || !nextProps.dateRange) {
      return;
    }

    if (
      nextProps.dateRange.startDate !== this.props.dateRange.startDate ||
      nextProps.dateRange.endDate !== this.props.dateRange.endDate
    ) {
      this.props.loadNetworkFollowers(this.props.networkId);
    }
  }

  render() {
    const { status, followers } = this.props;

    switch (status) {
      case ERROR:
        return <span data-qa="network-followers-error" />;
      default:
        break;
    }

    if (!followers && status !== LOADING) return null;

    return (
      <div data-qa="network-followers-chart" className={styles.container}>
        <Type as="p" variant={Type.heading3}>
          <FormattedMessage
            id="network.audience.followers.title"
            description="Title of followers chart"
            defaultMessage="Followers"
          />
        </Type>
        {this.props.status === LOADING ? (
          <div style={{ width: '100%', height: '350px' }}>
            <LoadingIndicator />
          </div>
        ) : (
          <PerformanceOverTimeChart
            performanceData={this.props.followers!}
            fill="#f573a0"
            stroke="#f573a0"
            name="Followers"
          />
        )}
      </div>
    );
  }
}

const selectors = createStructuredSelector<
  ReduxState,
  {
    status: ReturnType<typeof selectNetworkFollowersStatus>;
    followers: ReturnType<typeof selectNetworkFollowers>;
    dateRange: ReturnType<typeof selectDateRange>;
  }
>({
  status: selectNetworkFollowersStatus,
  followers: selectNetworkFollowers,
  dateRange: selectDateRange,
});

const actions = {
  loadNetworkFollowers,
};

export const ConnectedNetworkFollowers = connect(selectors, actions)(NetworkFollowers);
